export default __webpack_public_path__ + "static/media/cny-check-in-ms.708a66ac.gif";